import {
  SET_SORT_BY,
  SET_ORDER_BY,
  GET_VALUE_CONTENT,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
} from "../../shared/constants/ActionTypes";

const initalValueContent = {
  valueContent: [],
  valueContentCount: 0,
  page: 1,
  search: "",
  courseId: "",
  valueContentId: "",
  sortby: "",
  orderby: "desc",
};

const ValueContentReducer = (state = initalValueContent, action) => {
  switch (action.type) {
    case GET_VALUE_CONTENT:
      return {
        ...state,
        valueContent: action.payload.valueContent?.valueContentDetails,
        valueContentCount: action.payload.total,
        valueContentId: action.payload.valueContentId,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default ValueContentReducer;
